import React from 'react';
import { Col, Row } from 'react-bootstrap';

const OutletDetailField = ({ label, data, or = '' }) => (
  <Row>
    <Col md={6}>
      {label}
      :
    </Col>
    <Col md={6}>
      {data || or}
    </Col>
  </Row>
);

export default OutletDetailField;



// WEBPACK FOOTER //
// ./src/components/common/outlet/outlet-detail-field.jsx